import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useSelectorApp } from "../../../lib/redux";
import {
  ADLE_DOMAIN,
  BUZZLY_DOMAIN,
  IS_ADLE_DOMAIN,
} from "../../../utils/constants";

const Navbar = () => {
  const { theme } = useSelectorApp((state) => state.ui);

  return (
    <Box
      component="nav"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 3,
        "@media (max-width: 480px)": {
          gap: "8px",
          alignItems: "flex-start",
          flexDirection: "column",
        },
      }}
    >
      <Avatar
        src={theme.logoLogin}
        alt="Logo"
        variant="square"
        sx={{
          width: "fit-content",
          height: "52px",
          backgroundColor: "transparent",
          borderRadius: 0,
          overflow: "visible",
          ".MuiAvatar-img": {
            width: "auto",
            height: "100%",
            maxWidth: "155px",
            objectFit: "contain",
            objectPosition: "left center",
          },
        }}
      />
      <Typography
        sx={{
          fontSize: "14px",
          color: "text.secondary",
        }}
      >
        {IS_ADLE_DOMAIN ? ADLE_DOMAIN : BUZZLY_DOMAIN}
      </Typography>
    </Box>
  );
};

export default Navbar;
